import { useEffect } from "react";
import { useSSE } from "./use-sse";
import { useToast } from "./use-toast";
import { SmsMessage } from "../components/Message";
import { useHistory } from "react-router";

const preventNotificationsIdSet = new Set();

export function useNotificationPrevention(contactId: string) {
  useEffect(() => {
    if (contactId) preventNotificationsIdSet.add(contactId);
    return () => {
      if (contactId) preventNotificationsIdSet.delete(contactId);
    };
  }, [contactId]);
}

export default function useMessageNotifications() {
  const history = useHistory();
  const showToast = useToast();
  useSSE("notification", (notification) => {
    if (notification.payload.event !== "inbound_sms_message_created") return;
    if (preventNotificationsIdSet.has(notification.payload.contactId)) return;

    const message = notification.payload;
    showToast(
      <SmsMessage
        direction="inbound"
        author={[
          message.contact.firstName || "",
          message.contact.lastName || "",
        ]
          .join(" ")
          .trim()}
      >
        {message.body}
      </SmsMessage>,
      {
        white: true,
        onClick: () => {
          history.push(`/app/messages/inbox/${message.contactId}/messages`);
        },
      }
    );
  });
}
